import React from 'react';
import ReactDOM from 'react-dom';
import ArchivedUnitsSearchGrid from './ArchivedUnitsApp';
import './css/bootstrap/archived-units-iso.css';
import './css/archivedunits.css';

ReactDOM.render(<ArchivedUnitsSearchGrid />, document.getElementById('ArchivedUnitsApp'));


// WEBPACK FOOTER //
// ./src/index.js